"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.pushToCustomIcons = void 0;
var customIcons = [];

var pushToCustomIcons = function pushToCustomIcons(iconArray) {
  if (iconArray.length > 0) iconArray.forEach(function (icon) {
    return customIcons.push(icon);
  });
};

exports.pushToCustomIcons = pushToCustomIcons;
var _default = customIcons;
exports.default = _default;